import { Component, OnInit, Input } from '@angular/core';
import { trigger, state, style, animate, transition } from '@angular/animations';

@Component({
  selector: 'app-text-menu',
  templateUrl: './text-menu.component.html',
  styleUrls: ['./text-menu.component.scss'],
  // animations: [
  //   trigger('viewportAnimation', [
  //     state('initial', style({
  //       opacity: 0.0
  //     })),
  //     state('final', style({
  //       opacity: 1.0
  //     })),
  //     transition('initial=>final', animate('2000ms')),
  //     transition('final=>initial', animate('1000ms'))
  //   ]),
  // ]
})
export class TextMenuComponent implements OnInit {


  @Input() header: string = "";
  @Input() subHeader: string = "";
  @Input() textLeft: string = "";
  @Input() textRight: string = "";

  constructor() { }

  ngOnInit() {
  }

  currentState = 'initial';

  inViewPort(event)
  {
    if(event.visible == true)
    {
      this.currentState = 'final';
    }
    else{
      this.currentState = 'initial';
    }
  }

  


}
